<template>
  <div class="cellphone-input">
    <vue-tel-input 
      ref="input"
      v-model="content" 
      @onInput="handleInput" 
      :placeholder="placeholder"
      :defaultCountry="defaultCountry"
      :inputOptions="{
        tabindex: 1
      }"
      :dropdownOptions="{
        tabindex: 999
      }" />
  </div>
</template>

<script>
  import { VueTelInput } from 'vue-tel-input'
  import { mapGetters } from 'vuex'

  export default {
    name: 'CellphoneInput',

    components: {
      VueTelInput
    },

    props: ['value', 'placeholder'],

    mounted () {
      this.$emit('load', this.$refs.input)
    },

    computed: {
      ...mapGetters(['account']),

      defaultCountry () {
        if (this.account && this.account.country) {
          return this.account.country.toLowerCase()
        } else if (this.$cookies.get('country_code') !== 'INTL') {
          return this.$cookies.get('country_code')
        }
      }
    },

    data () {
      return {
        // preferredCountries: ['us', 'mx', 'cl', 'gb', 'be', 'cz', 'dk', 'de', 'es', 'fr', 'ie', 'it', 'nl', 'at', 'pl', 'pt', 'ch', 'se', 'au', 'nz', 'za'],
        content: this.value
      }
    },

    methods: {
      handleInput ({ number, isValid, country }) {
        this.$emit('input', this.content, country)
      }
    },

    watch: {
      value (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.content = newVal
        }
      }
    }
  }
</script>

<style lang="postcss">
.cellphone-input {
  .vue-tel-input {
    @apply border border-gray-300 rounded shadow-sm;

    input {
      @apply bg-white border border-gray-300 rounded flex w-full px-3 h-10;

      &:focus {
        @apply ring-0;
      }
    }

    &:focus-within {
      @apply ring border-indigo-500 outline-none;
    }

    .vti__dropdown {
      @apply outline-none rounded-l;

      &:hover {
        @apply bg-gray-100;
      }
    }

    .iti-flag {
      @apply shadow-none;
    }

    .vti__dropdown-list {
      @apply border-gray-200 shadow rounded-md;

      &.below {
        @apply top-full transform translate-y-1;
      }
    }

    .dropdown {
      &:focus,
      &:active {
        @apply outline-none;
      }

      &:hover,
      &.open {
        @apply bg-gray-50;
      }
    }

    ul {
      @apply border;
    }

    li {
      @apply py-3 px-4;

      &:hover,
      &.highlighted {
        @apply bg-indigo-100;
      }

      .iti-flag {
        @applr mr-4;
      }

      span {
        @apply text-gray-500;
      }
    }

    .last-preferred {
      @apply border-b;
    }
  }
}
</style>